document.querySelectorAll('.js-tab-nav a').forEach(tabLink => {
    tabLink.addEventListener('click', function(event) {
        event.preventDefault();
        const targetId = this.getAttribute('href').trim().replace('#', '');
        const targetTab = document.getElementById(targetId);

        if (targetTab) {
            document.querySelectorAll('.js-tab-nav, .accordion-mobile-new').forEach(el => {
                el.classList.remove('active');
            });
            this.closest('.js-tab-nav').classList.add('active');
            targetTab.classList.add('active');
        }
    });
});


document.querySelectorAll('.js-subtab-nav a').forEach(subTabLink => {
    subTabLink.addEventListener('click', function(event) {
        event.preventDefault();

        const targetId = this.getAttribute('href').trim().replace('#', '');
        const targetTab = document.getElementById(targetId);
        const parentAccordion = this.closest('.accordion-mobile-new__panel');

        if (targetTab && parentAccordion) {
            parentAccordion.querySelectorAll('.js-subtab-nav, .product-bundle-subcontent').forEach(el => {
                el.classList.remove('active');
            });
            this.closest('.js-subtab-nav').classList.add('active');
            targetTab.classList.add('active');
        }
    });
});


// document.querySelectorAll('.product-bundle-subaccordions').forEach(item => {
//     item.addEventListener('click', () => {
//         const parent = item.closest('.tab-content');
//         if (!parent.classList.contains('active-height')) {
//             parent.classList.add('active-height');
//         }
//     });
// });

// document.querySelectorAll('.accordion-mobile__heading').forEach(item => {
//     item.addEventListener('click', () => {
//         document.querySelectorAll('.active-height').forEach(activeItem => {
//             activeItem.classList.remove('active-height');
//         });
//     });
// });




    document.addEventListener("DOMContentLoaded", function (event) {
        var acc = document.getElementsByClassName("sub-accordion-mobile-new--nav");
        var panel = document.getElementsByClassName("accordion-mobile-new__panel--content");
        for (var i = 0; i < acc.length; i++) {
            acc[i].onclick = function () {
                var setClasses = !this.classList.contains("active");
                setClass(acc, "active", "remove");
                setClass(panel, "show", "remove");
                if (setClasses) {
                    this.classList.toggle("active");
                    this.nextElementSibling.classList.toggle("show");                
                    var scrollTarget = this.closest(".subaccordion-mobile-new > div").querySelector(".accordion-mobile--target");
                    if (scrollTarget) {
                        setTimeout(function () {
                            scrollTarget.scrollIntoView({ behavior: "smooth", block: "start" });
                        }, 500);    
                    }
                }
            };
        }
        function setClass(els, className, fnName) {
            for (var i = 0; i < els.length; i++) {
                els[i].classList[fnName](className);
            }
        }
    });

    document.addEventListener("DOMContentLoaded", function (event) {
        var acc = document.getElementsByClassName("accordion-mobile-new--nav");
        var panel = document.getElementsByClassName("accordion-mobile-new__panel");
        for (var i = 0; i < acc.length; i++) {
            acc[i].onclick = function () {
                var setClasses = !this.classList.contains("active");
                setClass(acc, "active", "remove");
                setClass(panel, "show", "remove");
                if (setClasses) {
                    this.classList.toggle("active");
                    this.nextElementSibling.classList.toggle("show");
              
                    var scrollTarget = this.closest(".accordion-mobile-new").querySelector(".accordion-mobile--target");
                    if (scrollTarget) {
                        setTimeout(function () {
                            scrollTarget.scrollIntoView({ behavior: "smooth", block: "start" });
                        }, 500);    
                    }
                }
            };
        }
        function setClass(els, className, fnName) {
            for (var i = 0; i < els.length; i++) {
                els[i].classList[fnName](className);
            }
        }
    });



document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll("a[data-scroll-accordion]").forEach(anchor => {
        anchor.addEventListener("click", function (e) {
            e.preventDefault();

            let targetClass = this.getAttribute("data-scroll-accordion");
            let targetElement = document.querySelector(`.${targetClass}`);

            if (targetElement) {
                targetElement.scrollIntoView({ behavior: "smooth", block: "start" });
            }
        });
    });
});


document.addEventListener("DOMContentLoaded", function() {
    const hash = window.location.hash;

    if (hash && hash.includes("product")) {
        return;
    }

    if (hash) {
        const className = hash.substring(1);
        const activeTab = document.querySelector(`.js-tab-nav.${className}`);

        if (activeTab) {
            document.querySelectorAll('.js-tab-nav').forEach(tab => tab.classList.remove('active'));
            activeTab.classList.add('active');

            const link = activeTab.querySelector('a');
            setTimeout(function () {
                if (link) {
                    link.dispatchEvent(new Event("click", { bubbles: true, cancelable: true }));
                }

                if (window.innerWidth < 700) {
                    const activeTabWithClass = document.querySelector('.accordion-mobile-new.active');
                    if (activeTabWithClass) {
                        const accordionNav = activeTabWithClass.querySelector('.accordion-mobile-new--nav');
                        if (accordionNav) {
                            accordionNav.click();
                        }
                    }
                }
            }, 100);           

            const targetSection = document.querySelector('.tabs-scroll-to');
            if (targetSection) {
                if (targetSection) {
                    setTimeout(function () {
                        targetSection.scrollIntoView({ behavior: "smooth" });
                    }, 0);
                }
            }           
        }
    }
});